import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // home2 is the main landing page — standalone (it ships its own header/footer),
  // so it sits outside the main layout. `pathMatch: 'full'` keeps it to the exact
  // root URL; all other paths fall through to the main-layout route below.
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/home2/home2.component').then(m => m.Home2Component),
  },
  // Legacy home links now resolve to the new home page.
  { path: 'home', redirectTo: '', pathMatch: 'full' },
  { path: 'home2', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: 'products',
        loadComponent: () => import('./features/products/products.component').then(m => m.ProductsComponent),
      },
      {
        path: 'product/:slug',
        loadComponent: () => import('./features/product-detail/product-detail.component').then(m => m.ProductDetailComponent),
      },
      {
        path: 'search',
        loadComponent: () => import('./features/search-results/search-results.component').then(m => m.SearchResultsComponent),
      },
      {
        path: 'cart',
        loadComponent: () => import('./features/cart/cart.component').then(m => m.CartComponent),
      },
      {
        path: 'checkout',
        canActivate: [authGuard],
        loadComponent: () => import('./features/checkout/checkout.component').then(m => m.CheckoutComponent),
      },
      {
        path: 'checkout/confirmation',
        canActivate: [authGuard],
        loadComponent: () => import('./features/checkout/order-confirmation/order-confirmation.component').then(m => m.OrderConfirmationComponent),
      },
      {
        path: 'account',
        canActivate: [authGuard],
        loadComponent: () => import('./features/account/account.component').then(m => m.AccountComponent),
        children: [
          { path: '', redirectTo: 'orders', pathMatch: 'full' },
          {
            path: 'orders',
            loadComponent: () => import('./features/account/orders/orders.component').then(m => m.OrdersComponent),
          },
          {
            path: 'orders/:id',
            loadComponent: () => import('./features/account/orders/order-detail/order-detail.component').then(m => m.OrderDetailComponent),
          },
          {
            path: 'wishlist',
            loadComponent: () => import('./features/account/wishlist/wishlist.component').then(m => m.WishlistComponent),
          },
          {
            path: 'profile',
            loadComponent: () => import('./features/account/profile/profile.component').then(m => m.ProfileComponent),
          },
          {
            path: 'addresses',
            loadComponent: () => import('./features/account/addresses/addresses.component').then(m => m.AddressesComponent),
          },
        ],
      },
      {
        path: 'brands',
        loadComponent: () => import('./features/brands/brands.component').then(m => m.BrandsComponent),
      },
      {
        path: 'brand/:slug',
        loadComponent: () => import('./features/brand-detail/brand-detail.component').then(m => m.BrandDetailComponent),
      },
      {
        path: 'about',
        loadComponent: () => import('./features/about/about.component').then(m => m.AboutComponent),
      },
      {
        path: 'contact',
        loadComponent: () => import('./features/contact/contact.component').then(m => m.ContactComponent),
      },
      {
        path: 'faq',
        loadComponent: () => import('./features/faq/faq.component').then(m => m.FaqComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./features/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
      },
      {
        path: 'terms-conditions',
        loadComponent: () => import('./features/terms-conditions/terms-conditions.component').then(m => m.TermsConditionsComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
